import { styled } from "theme/default/styled";
import { setFlexDFAIC } from "theme/setter/setFlexValues/setFlexDFAIC";

export const SRightControls = styled.div`
  ${setFlexDFAIC};
`;
